module.exports = __webpack_public_path__ + "f0ba75822c0cda16ace2de3837673dcb.png";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_3.png
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_3.png
// module chunks = 40